import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import * as correlatividadesService from '../../services/correlatividades/correlatividadesService';
import {
  classifyCorrelatividadesError,
  toUpdateCorrelatividadRendirPayload
} from '../../services/correlatividades/correlatividadesDto';
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import Select from '../common/AppSelect';
import { findSelectOptionByLabel } from '../../services/selectOptions';

registerLocale('es', es)

const optionsCuatrimestre = [
  { value: 'A', label: 'Aprobada' },
  { value: 'R', label: 'Regular' }
];


export class UpdateCorrelativaRendir extends Component {
  static displayName = UpdateCorrelativaRendir.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      descripcion: "",
      showErrorMessage: false,
      success: false,
      errorMessage: "",
      showLookupAnios: false,
      showLookupCursada: false,
      tagData: [{ id: "", text: "" }],
      startDate: new Date(),
      endDate: new Date(),
      startInscriptionDate: new Date(),
      endInscriptionDate: new Date(),
      llamado: "",
      valueDictado: { value: '', label: '' },
      materiaInicial: { codigo: 0, nombre: "", codigoMostrar:""},
      materiaCorrelativa: { codigo: 0, nombre: "", codigoMostrar: "" },
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      correlativaCondicion: "",
      correlativaCondicionValor: "",
      tipoLookup: null, // 'MATERIA' | 'CORRELATIVA'
    };
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
    this.handleDescripcionChangeInput = this.handleDescripcionChangeInput.bind(this);
    this.handleLlamadoChangeInput = this.handleLlamadoChangeInput.bind(this);
    this.handleShowAniosLookup = this.handleShowAniosLookup.bind(this);
    this.handleSelectAnioItem = this.handleSelectAnioItem.bind(this);
    this.handleHideLookup = this.handleHideLookup.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleEndInscripcionDate = this.handleEndInscripcionDate.bind(this);
    this.handleStartInscriptionDate = this.handleStartInscriptionDate.bind(this);
    this.handleShowCursadaLookup = this.handleShowCursadaLookup.bind(this);
    this.handleSelectCursadaItem = this.handleSelectCursadaItem.bind(this);
    this.handleHideLookup1 = this.handleHideLookup1.bind(this);
    this.handleDictadoChangeInput = this.handleDictadoChangeInput.bind(this);
    this.handleShowLookup = this.handleShowLookup.bind(this);
    this.handleHideLookup = this.handleHideLookup.bind(this);
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWInscripcionExamen');
    if (canAccess) {
      this.populateData();
    }
  }

  handleConfirmButton = () => {
    if (this.state.details === "1") {
      this.setState({ success: true })
    } else {
      var errorMessage = "";
      var isOkToSave = this.isOkToSave();

      if (!isOkToSave) {
        errorMessage = "Todos los campos son obligatorios";
        this.setState({ showErrorMessage: true, errorMessage: errorMessage });
      } else {
        this.saveStudent();
      }
    }
  }

  handleDictadoChangeInput = e => {
    this.setState({ dictado: e.value, valueDictado: e });
  }

  handleCorrelatividadesError(error, prefix = '') {
    const outcome = classifyCorrelatividadesError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return { success: false, errorMessage: '' };
    }
    return {
      success: false,
      errorMessage: outcome.message
    };
  }

  async populateData() {
    try {
      const model = await correlatividadesService.getCorrelatividadRendir(this.state.id);
      const defaultValuePractica = findSelectOptionByLabel(
        optionsCuatrimestre,
        model.correlatividadRendirCondicion
      );
      this.setState({
        errorMessage: "",
        materiaInicial: {
          codigo: model.materiaCarreraCod,
          nombre: model.materiaCarreraNombre,
          codigoMostrar: model.materiaCarreraMostrar
        },
        materiaCorrelativa: {
          codigo: model.materiaCarreraCod2,
          nombre: model.materiaCarreraNecesaria,
          codigoMostrar: model.materiaCarreraMostrar2
        },
        correlativaCondicion: defaultValuePractica?.label ?? '',
        correlativaCondicionValor: defaultValuePractica?.value ?? '',
        valueDictado: defaultValuePractica
      });
    } catch (error) {
      const outcome = this.handleCorrelatividadesError(error);
      if (outcome.errorMessage) {
        this.setState({ errorMessage: outcome.errorMessage });
      }
    }
  }

  handleEndInscripcionDate = (date) => {
    this.setState({ endInscriptionDate: date });
  }

  handleStartInscriptionDate = (date) => {
    this.setState({ startInscriptionDate: date });
  }

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  }

  handleShowCursadaLookup = () => {
    this.setState({ showLookupCursada: true });
  }

  handleStartDate = (date) => {
    this.setState({ startDate: date });
  }

  handleEndDate = (date) => {
    this.setState({ endDate: date });
  }

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  }
  handleHideLookup1 = () => {
    this.setState({ showLookupCursada: false });
  }

  handleDescripcionChangeInput = e => {
    this.setState({ descripcion: e.target.value });
  }

  handleLlamadoChangeInput = e => {
    this.setState({ llamado: e.target.value });
  }

  handleSelectAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.setState({
      materiaInicial: {
        codigo: anioProperties[0],
        nombre: anioProperties[2],
        codigoMostrar: anioProperties[1],
      },
      showLookupAnios: false
    });
  }

  handleSelectCursadaItem = (e) => {
    const anioProperties = e.split('%');
    this.setState({
      materiaCorrelativa: {
        codigo: anioProperties[0],
        nombre: anioProperties[2],
        codigoMostrar: anioProperties[1],
      },
      showLookupAnios: false
    });
  }

  handleShowLookup = (tipo) => {
    this.setState({
      showLookup: true,
      tipoLookup: tipo
    });
  };

  handleHideLookup = () => {
    this.setState({
      showLookup: false,
      tipoLookup: null
    });
  };

  handleChange = (e) => {
    this.setState({ descripcion: e.value });
  }


  render() {
    if (this.state.success) {
      return <Redirect to="/md-crendir" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail
      ? 'Detalle de Correlatividad para Rendir'
      : 'Modificar datos de Correlatividad para Rendir';
    const { loading } = this.state;
    const materiaInicialDisplay = this.state.materiaInicial.codigoMostrar + ' - ' + this.state.materiaInicial.nombre;
    const materiaCorrelativaDisplay = this.state.materiaCorrelativa.codigoMostrar + ' - ' + this.state.materiaCorrelativa.nombre;

    return (
      <div className="md-page md-update-crendir">
        <Link className="md-page__back-link" to="/md-crendir">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados de la correlatividad para rendir.'
            : 'Actualice la materia, la correlativa o la condición de inscripción.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Materia</span>
            <div className="md-page__picker-block">
              {!isDetail && !loading ? (
                <button type="button" className="md-page__picker-link" onClick={() => this.handleShowLookup('MATERIA')}>
                  Seleccionar materia
                </button>
              ) : null}
              <div className="md-page__field-readonly">{materiaInicialDisplay}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Correlativa</span>
            <div className="md-page__picker-block">
              {!isDetail && !loading ? (
                <button type="button" className="md-page__picker-link" onClick={() => this.handleShowLookup('CORRELATIVA')}>
                  Seleccionar correlativa
                </button>
              ) : null}
              <div className="md-page__field-readonly">{materiaCorrelativaDisplay}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">
              {isDetail ? 'Condición de Correlativa' : 'Condición de Inscripción'}
            </span>
            {isDetail ? (
              <div className="md-page__field-readonly">{this.state.correlativaCondicion}</div>
            ) : (
              <Select
                className="md-page__field-select"
                value={this.state.valueDictado}
                options={optionsCuatrimestre}
                onChange={this.handleDictadoChangeInput}
                disabled={loading}
              />
            )}
          </div>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={loading}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>

        {this.state.showLookup && this.state.tipoLookup === 'MATERIA' ? (
          <LookupMaterias selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
        {this.state.showLookup && this.state.tipoLookup === 'CORRELATIVA' ? (
          <LookupMaterias selectItem={this.handleSelectCursadaItem} hideLookup={this.handleHideLookup} />
        ) : null}
      </div>
    );
  }

  isOkToSave() {
    return true;
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await correlatividadesService.saveCorrelatividadRendir(
        toUpdateCorrelatividadRendirPayload({
          id: this.state.id,
          materiaInicialCod: this.state.materiaInicial.codigo,
          materiaCorrelativaCod: this.state.materiaCorrelativa.codigo,
          condicion: this.state.valueDictado.value
        })
      );
      this.setState({ loading: false, success: true, errorMessage: "" });
    } catch (error) {
      const outcome = this.handleCorrelatividadesError(error);
      this.setState({ loading: false, success: false, errorMessage: outcome.errorMessage });
    }
  }
}
